import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Grid,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import { Form, Formik, FormikValues } from "formik";
import React, { SyntheticEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useCreateEcsMutation } from "../../../../generated/graphql";
import { a11yProps } from "../../../../utils/helper";
import TabPanel from "../../../common/TabPanel/TabPanel";
import StudyReport from "./StudyReport/StudyReport";
import { STUDY_CLOSEOUT_REPORT_SUB_SECTIONS } from "../utils";

type IRProps = {};

const StudyClose = (props: IRProps) => {
  const [StudyCloseSubmissionTabValue, setStudyCloseSubmissionTabValue] =
    useState(0);
  const handleECSubmissionTabChange = (
    event: SyntheticEvent,
    newValue: any
  ) => {
    setStudyCloseSubmissionTabValue(newValue);
  };

  return (
    <Card>
      <CardContent className="pd-x-30 pd-y-30">
        <Box className="mg-b-40">
          <Typography className="mg-b-10" variant="h2" component="h2">
            Study Close Out Report
          </Typography>
          <Container maxWidth={false}>
            <div>
              <Box className={`custom-tabs`}>
                <Tabs
                  value={StudyCloseSubmissionTabValue}
                  onChange={handleECSubmissionTabChange}
                  aria-label="tabs"
                >
                  <Tab
                    label={
                      STUDY_CLOSEOUT_REPORT_SUB_SECTIONS.STUDY_COMPLETION_REPORT
                    }
                    {...a11yProps(0)}
                  />
                  <Tab
                    label={
                      STUDY_CLOSEOUT_REPORT_SUB_SECTIONS.STUDY_TERMINATION_REPORT
                    }
                    {...a11yProps(1)}
                  />
                </Tabs>
                <TabPanel value={StudyCloseSubmissionTabValue} index={0}>
                  <StudyReport
                    value={
                      STUDY_CLOSEOUT_REPORT_SUB_SECTIONS.STUDY_COMPLETION_REPORT
                    }
                  />
                </TabPanel>
                <TabPanel value={StudyCloseSubmissionTabValue} index={1}>
                  <StudyReport
                    value={
                      STUDY_CLOSEOUT_REPORT_SUB_SECTIONS.STUDY_TERMINATION_REPORT
                    }
                  />
                </TabPanel>
              </Box>
            </div>
          </Container>
        </Box>
      </CardContent>
    </Card>
  );
};

export default StudyClose;
